<template>
  <div>
    <picture>
      <template v-for="(source, index) in imageSources">
        <source :key="index" :media="source.media" :sizes="source.sizes" :srcset="source.srcset.join(', ')">
      </template>
      <img class="psuedo-background-responsive-img" alt="background image" :src="imgSrc" onerror="this.style.display='none'">
    </picture>
    <slot></slot>
  </div>
</template>

<script>
import { ImageArea, ImageModel } from '@/models/image-model'
export default {
  name: 'ResponsiveImage',
  props: {
    heroImage: String,
    responsiveHandle: String,
    brand: Object,
    dealer: Object,
    category: {
      type: String,
      default: 'unknown'
    }
  },
  data () {
    const respHeroModel = {}
    return this.dataReset(respHeroModel)
  },
  computed: {
    imageSources () {
      let sources
      if (this.heroImage) {
        sources = []
      } else {
        sources = this.respHeroModel.sources
      }
      return sources
    },
    imgSrc () {
      let src
      if (this.heroImage) {
        src = process.env.VUE_APP_ASSET_HOST + this.heroImage
      } else {
        src = this.respHeroModel.src
      }
      return src
    }
  },
  methods: {
    dataReset (respHeroModel) {
      respHeroModel = ImageModel.build({
        imageArea: ImageArea.responsiveHero,
        brand: this.brand.name,
        category: this.category,
        dealer: this.dealer
      })
      return {
        respHeroModel: respHeroModel
      }
    }
  }
}
</script>

<style scoped>
/* styles for xs screens go here */
.psuedo-background-responsive-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
}
@media only screen and (min-width: 768px) {
}
@media only screen and (min-width: 992px) {
}
@media only screen and (min-width: 1200px) {
}
</style>
